import { HttpError } from '@/api/HttpError.ts';

async function get<TResponse>(uri: string): Promise<TResponse> {
  const response = await fetch(uri);

  if (!response.ok) {
    throw new HttpError(response.status, response.statusText, uri);
  }

  return (await response.json()) as TResponse;
}

async function post<TInput, TResponse>(uri: string, body: TInput): Promise<TResponse> {
  const response = await fetch(uri, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  });

  if (!response.ok) {
    throw new HttpError(response.status, response.statusText, uri);
  }

  return (await response.json()) as TResponse;
}

async function put<TInput, TResponse>(uri: string, body: TInput): Promise<TResponse> {
  const response = await fetch(uri, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  });

  if (!response.ok) {
    throw new HttpError(response.status, response.statusText, uri);
  }

  return (await response.json()) as TResponse;
}

async function del(uri: string) {
  const response = await fetch(uri, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
    },
  });

  if (!response.ok) {
    throw new HttpError(response.status, response.statusText, uri);
  }
}

export const api = { get, post, put, delete: del };
